/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

export default {
  getTripPreferencesList: (params) => {
    return axios.get(API_ENDPOINTS.GET_TRIP_PREFERENCES, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params,
    });
  },
  getTripPreferenceById: (id) => {
    return axios.get(API_ENDPOINTS.GET_TRIP_PREFERENCE_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
  addTripPreference: (data) => {
    return axios.post(API_ENDPOINTS.ADD_TRIP_PREFERENCE, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "multipart/form-data",
      },
    });
  },
  updateTripPreference: (id, data) => {
    let url = API_ENDPOINTS.UPDATE_TRIP_PREFERENCE_BY_ID + "/" + id;
    return axios.put(url, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "multipart/form-data",
      },
    });
  },
  deleteTripPreference: (id) => {
    return axios.delete(API_ENDPOINTS.DELETE_TRIP_PREFERENCE_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
};
